
        var result = require("!!../../../../node_modules/css-loader/index.js!./groups.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/groups/groups.component.css
// module id = 537
// module chunks = 0